/**
 * @generated SignedSource<<d278a57887c8562f8ad20bc6fa24d566>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterButtonTodoTags_tags$data = ReadonlyArray<{
  readonly color: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTagButtonContentActive_todoCategoryTag">;
  readonly " $fragmentType": "FilterButtonTodoTags_tags";
}>;
export type FilterButtonTodoTags_tags$key = ReadonlyArray<{
  readonly " $data"?: FilterButtonTodoTags_tags$data;
  readonly " $fragmentSpreads": FragmentRefs<"FilterButtonTodoTags_tags">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "FilterButtonTodoTags_tags",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoTagButtonContentActive_todoCategoryTag"
    }
  ],
  "type": "TodoCategoryTag",
  "abstractKey": null
};

(node as any).hash = "2914597a25fddff086955e4e90a8f5df";

export default node;
